import React, {} from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import mainbg from 'images/mainbg.png';

const FilterDiv = styled.div`
	width: 100vw;
	padding: 40px;
	background-image: url(${mainbg});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center center;
	position: relative;

	ul {
		list-style: disc;
		margin-left: 20px;
	}
`;

const LayerColor = styled.div`
	height: 100%;
	width: 100%;
	position: absolute !important;
	top: 0;
	left: 0;
	background-color: rgba(3, 71, 129, 0.6);
	z-index: 20;
`;

const Container = styled.div`
	z-index: 100;
`;

const Title = styled.div`
	z-index: 100;
`;

const MainText = styled.div`
	line-height: 22px !important;
`;

export const Filter = () => {
	const { t } = useTranslation();

	return (
		<>
			<FilterDiv className='block-fullwidth padding-40'>
				<LayerColor />

				<Title className='color-white col-1 font-24 font-bold text-uppercase margin-bottom-20'>{t('Система онлайн-бронирования отелей')}</Title>

				<Container className='col-1 flex row wrap justify-between color-white'>
					<MainText className='col-1 font-16 padding-5'>
						{t('Вы можете легко взаимодействовать с нашей системой бронирования! У вас есть два удобных варианта:')}
					</MainText>
					<ul>
						<li className='font-16'>
							{t('Использовать наш сайт acase.ru: просто заходите на сайт и работайте в личном кабинете.')}
						</li>
						<li className='font-16'>
							{t('Сделать техническую интеграцию: если вам нужно, чтобы наша система работала вместе с вашим собственным сайтом или приложением, мы предлагаем бесплатную интеграцию по API. Это позволит вам автоматизировать процессы и существенно сэкономить на фонде оплате труда.')}
						</li>
					</ul>
					<MainText className='col-1 font-16 padding-5'>
						{t('Для отелей:')} {t('Сделав интеграцию с нами, вы сможете передавать нам данные по тарифам, номерному фонду, наличию мест и ценам в режиме реального времени.')} {t('Мы уже работаем со всеми наиболее популярными менеджерами каналов и облачными системами управления отелями. С удовольствием подключим и вас!')}
					</MainText>
					<MainText className='col-1 font-16 padding-5'>
						{t('Для ОТА, Агентств делового туризма и OBT:')} {t('Сделав интеграцию с нами, ваши клиенты смогут бронировать наши отели на вашем сайте или приложении.')}
					</MainText>
					<MainText className='col-1 font-16 padding-5'>
						{t('Для получения технической спецификации перейдите в нужный раздел')}
					</MainText>
				</Container>
			</FilterDiv>
		</>
	);
};